<template src="./VehicleTypeAdd.html"></template>
<script>
// import { createNamespacedHelpers } from "vuex";
// const { mapState } = createNamespacedHelpers("vehicleType");
// import checkbox from "@/components/CheckBoxHeader";
import checkboxItem from "@/components/CheckBox";
import { MESSAGES } from "@/utils/constants";
import { orderBy } from "@progress/kendo-data-query";
import $ from "jquery";

import {
  notify,
  notifyApiError,
  notifyWarn,
} from "@/utils/notification-helper";
import Vue from "vue";
import { VEHICLE_TYPE } from '@/utils/map/mapUtils';

function getVehicleTypes() {
  let arr= [];
  for (const key in VEHICLE_TYPE) {
      arr.push(VEHICLE_TYPE[key]);
  }
  return arr;
}
export default {
  data: function () {
    return {
      add: this.$route.params.add,
      vehicleType: null,
      noofwheels: null,
      vehicleId: null,
      vehicleTypesV2: getVehicleTypes(),
      id: null,
      gridHeight: window.innerHeight - 120,
      skip: 0,
      take: 10,
      pageSize: 10,
      pageable: {
        pageSizes: true,
        previousNext: true,
      },
      sort: [{ field: "id", dir: "asc" }],
      selectedField: "selected",
      staticColumns: [
        { cell: checkboxItem, width: "60px" },
        { field: "id", title: "ID", hidden: "true" },
        { field: "name", title: "Name" },
      ],
      vehicleTypeList: [],
      type:null,
      
    };
  },
  methods: {
    goToListPage: function () {
      this.$router.push({ name: "vehicle-management" });
    },
    sortChangeHandler: function (e) {
      this.sort = e.sort;
    },
    pageChangeHandler: function (event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    expandPanel() {
      $("#panelbar").kendoPanelBar();
      var panelBar = $("#panelbar").data("kendoPanelBar");
      panelBar.expand($("#item1"));
    },
    addVehicleTypes: function () {
      console.log('Adding vehicle types');
      if (this.vehicleType) {
        const data = {
          noofwheels: this.noofwheels,
          name: this.vehicleType.name,
          id: this.vehicleType.id,
          type: this.type
        }
        if (this.add) {
          this.$store
            .dispatch("vehicleType/addVehicleType", data)
            .then((resp) => {
              console.log("addingdata",resp)
              if(resp.status){
              notify(MESSAGES.RECORD_CREATE_SUCCESS);
              this.goToListPage();
              }
              else{
                let str = resp.message.split(" ");
                str.pop()
                notifyWarn(str.join(" "))
              }
            })
            .catch(notifyApiError);
        } else {
          data.id = this.id;
          this.$store
            .dispatch("vehicleType/updateVehicleType", data)
            .then(() => {
              notify(MESSAGES.CHANGES_SAVE_SUCCESS);
              this.goToListPage();
            })
            .catch(() => {
              notifyWarn('No Changes Applied')
              this.goToListPage();
            });
          // alert('update is not ready')
        }
      } else {
        return notifyWarn("Please select Vehicle Type");
      }
    },
    onHeaderSelectionChange(event) {
      let checked = event.event.target.checked;
      this.$store.dispatch("vehicleType/changeSelectionStatus", checked);
    },
    onSelectionChange(event) {
      Vue.set(
        event.dataItem,
        this.selectedField,
        !event.dataItem[this.selectedField]
      );
    },
    onRowClick(event) {
      Vue.set(
        event.dataItem,
        this.selectedField,
        !event.dataItem[this.selectedField]
      );
    },
    async getDataOnLoad() {
      console.log('ON DATA TYPES');
      this.noofwheels = this.$route.params.noofwheels;
      this.vehicleType=this.vehicleTypedropdown.find(i=>{
        console.log("params",i.name)
        return i.name===this.$route.params.name})
      this.type = this.$route.params.type;
      console.log("selected",this.$route.params.name)
      this.id =  this.$route.params.id;
       await this.$store.dispatch("vehicleType/getAllVehicleTypes").then(()=>{
       this.vehicleTypeList =this.$store.getters["vehicleType/allVehicleTypes"]  

      });
      // await this.$store.dispatch("vehicleType/getAllVehicleTypes").then(() => {
      //   this.vehicleTypeList = this.$store.getters[
      //     "vehicleType/allVehicleTypes"
      //   ];
      // });
    },
    changeType(e){
      console.log("#e",e)
    },
    changeVehicleType(e){
      console.log(e.target.value)
      this.type=e.target.value;
    }
  },
  computed: {
    // ...mapState({
    //   vehicleTypeList: (state) => state.allVehicleTypes,
    // }),
    total() {
      return this.vehicleTypeList.length ? this.vehicleTypeList.length : 0;
    },
    items: {
      get: function () {
        return orderBy(
          this.vehicleTypeList.slice(this.skip, this.take + this.skip),
          this.sort
        );
      },
    },
    areAllSelected() {
      return (
        this.vehicleTypeList.findIndex((item) => item.selected === false) === -1
      );
    },
    columns() {
      return [...this.staticColumns];
    },
    vehicleTypedropdown(){
      return this.$store.getters["vehicleType/allVehicleTypes"]

    }
  },
  mounted() {
    this.getDataOnLoad();
    this.expandPanel();
  },
  created() {
    this.getDataOnLoad();
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
.k-form, .k-form-inline {
    font-size: 1rem;
    line-height: 1.5;
    padding: 1rem !important;
}
.page-header .title-text {
    font-size: 12px;
    margin-left: 10px;
}
.mobile_side_lbl{width: 70% !important;}
.mobile_side_btn{display: flex;}
.driver_header_mobile{flex-direction: row !important; overflow-x: auto; padding: 10px 10px 10px 10px;}
}
</style>
